import React, { useState } from "react";
import Style from "./LeftNavigation.module.css";
import { Link } from "react-router-dom";
// import Tab from "./tabs/Tab";
import { useEffect } from "react";
import { Alert20Regular, ClockAlarm20Regular } from "@fluentui/react-icons";
// import { useHistory } from "react-router-dom";
// import { useLocation } from "react-router-dom";

const LeftNavBar = (props) => {
  const { currentTab, setCurrentTab } = props;
  const [activeTab, setActiveTab] = useState(1);
  //   const history = useHistory();
  //   const location = useLocation();

  //   const handleActiveTab = (e) => {
  //     setActiveTab(e);
  //     setCurrentTab(e);
  //   };

  const tabs = [
    {
      id: 1,
      label: "Notifications",
      link: "/notifications/activity",
      logo: <Alert20Regular />,
      cssClass: Style.infoWrapper,
    },
    {
      id: 2,
      label: "Reminders",
      link: "/reminders/activity",
      logo: <ClockAlarm20Regular />,
      cssClass: Style.securityWrapper,
    },
    {
      id: 3,
      label: "Notification Settings",
      link: "/notifications/settings",
      logo: <Alert20Regular />,
      cssClass: Style.securityWrapper,
    },
  ];

  useEffect(() => {
    setActiveTab(currentTab);
  }, [currentTab]);

  return (
    <div className={Style.mainWrapper}>
      <div className={Style.wrapper}>
        <h4>Activity</h4>
        {tabs.map((item, index) => (
          <Link to={item.link}>
            <div
              className={`${
                activeTab === item.id ? Style.active : item.cssClass
              }`}
              key={index}
            >
              {activeTab === item.id && <span className={Style.activeBar} />}
              <span style={{ color: "#242424" }}>{item.logo}</span>
              <p className="mb-0 text-xsm-400 gray-light-black">{item.label}</p>
            </div>
          </Link>
        ))}
        {/* {tabs.map((item, index) => <Tab item={item} index={item.id} key={index} setActiveTab={handleActiveTab} isActive={activeTab === item.id} />)} */}
      </div>
    </div>
  );
};

export default LeftNavBar;
